(angular => {
  "use strict";

  angular.module("Pages").controller("Pages.credentialCtrl", [
    "$q",
    "moment",
    "Loader",
    "Toast",
    "AuthService",
    "ParticipantService",
    "EventService",
    credentialCtrl
  ]);

  function credentialCtrl($q, moment, loader, Toast, authService, participantService, eventService) {
    this.hasAnswered = false;
    this.user = authService.getTokenData();
    this.message = 'loading';

    loader.add($q.all([
      participantService.current(),
    ])).then(([participant]) => {
      this.message = null;
      this.event = participant.event;
      this.banner = this.event.assets.filter(a => a.type === "banner").map(a => a.path)[0];
      this.eventCredencial = this.event.assets.some(a => a.type === participant.company.type);
      this.participant = participant;
    });

    this.credential = () => {
      eventService.credential();
    };
  }
})(angular);
